export class LongBookingEmployeeModel {
    employeeId : string;
    Name : string;
}
